import { Col, Row } from 'antd';
import { useIntl } from 'react-intl';
import { FloatingFormItem } from '@/components/_common';

import DocumentTypesSelectField from '@/components/_common/DocumentTypesSelectField';
import EmployeesInfiniteSelectField from '@/components/_common/EmployeesInfiniteSelectField';

const ByFinancialSelects = () => {
  const intl = useIntl();

  return (
    <Row gutter={[24, 24]}>
      <Col xs={16}>
        <FloatingFormItem
          noStyle
          name="employeesIds"
          label={intl.formatMessage({ id: 'byFinancialForm.form.employees' })}
        >
          <EmployeesInfiniteSelectField mode="multiple" allowClear />
        </FloatingFormItem>
      </Col>

      <Col xs={16}>
        <FloatingFormItem
          noStyle
          name="documentTypeIds"
          label={intl.formatMessage({ id: 'byFinancialForm.form.documents' })}
        >
          <DocumentTypesSelectField mode="multiple" />
        </FloatingFormItem>
      </Col>
    </Row>
  );
};

export default ByFinancialSelects;
